import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalDiscountAll: [],
  generalDiscount: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalDiscountSlice = createSlice({
  name: "generalDiscount",
  initialState,
  reducers: {
    setGeneralDiscountAll: (state, action) => {
      state.generalDiscountAll = action.payload;
    },
    setGeneralDiscount: (state, action) => {
      state.generalDiscount = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralDiscountAll,
  setGeneralDiscount,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalDiscountSlice.actions;

export default generalDiscountSlice.reducer;
